import { createTheme } from '@mui/material/styles';

const tableHeadCjkOverride = {
  MuiTableCell: {
    styleOverrides: {
      head: { wordBreak: 'keep-all' },
    },
  },
};

// ---- WAYMORR brand foundation ----
const STEM = "'Stem', 'Suisse Intl', -apple-system, sans-serif";
const SUISSE = "'Suisse Intl', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

// Единая типографика: Suisse Intl (текст) + Stem (заголовки)
const brandTypography = {
  fontFamily: SUISSE,
  h1: { fontFamily: STEM, fontWeight: 700 },
  h2: { fontFamily: STEM, fontWeight: 700 },
  h3: { fontFamily: STEM, fontWeight: 700 },
  h4: { fontFamily: STEM, fontWeight: 700 },
  h5: { fontFamily: STEM, fontWeight: 700 },
  h6: { fontFamily: STEM, fontWeight: 700 },
  button: { textTransform: 'none', fontWeight: 600 },
};

const brandShape = { borderRadius: 8 };

// Встроенные поля даты и месяца (type="date"/"month") рисуют значок календаря браузером. Без color-scheme
// в тёмной теме значок остаётся чёрным на тёмном фоне — задаём схему по режиму темы.
const dateInputScheme = (mode) => ({
  MuiInputBase: {
    styleOverrides: {
      input: { colorScheme: mode },
    },
  },
});

// Светлая тема
const lightTheme = createTheme({
  palette: {
    mode: 'light', // Режим светлой темы
    primary: {
      main: '#2412A4', // Фирменный фиолетовый WAYMORR
    },
    secondary: {
      main: '#dc004e', // Вторичный цвет
    },
    background: {
      default: '#F6F8FA', // Фон страницы
      paper: '#FFFFFF', // Фон подложки
    },
    contrast: {
      yellow: '#FFCC00', // Контрастный желтый цвет
      green: '#34C759', // Контрастный зеленый цвет
      red: '#FF3B30', // Контрастный красный цвет
      gray: '#8E8E93', // Контрастный серый цвет
      blue: '#007AFF', // Контрастный синий цвет
    },
  },
  typography: brandTypography,
  shape: brandShape,
  components: { ...tableHeadCjkOverride, ...dateInputScheme('light') },
});

// Темная тема
const darkTheme = createTheme({
  palette: {
    mode: 'dark', // Режим темной темы
    primary: {
      main: '#8B72FF', // Фирменный фиолетовый, осветлённый для тёмного фона
    },
    secondary: {
      main: '#f48fb1', // Вторичный цвет
    },
    background: {
      default: '#080808', // Фон страницы
      paper: '#181818', // Фон подложки
    },
    text: {
      primary: '#ECECEC', // Основной цвет текста
    },
    contrast: {
      yellow: '#FFD60A', // Контрастный желтый цвет
      green: '#30D158', // Контрастный зеленый цвет
      red: '#FF453A', // Контрастный красный цвет
      gray: '#636366', // Контрастный серый цвет
      blue: '#0A84FF', // Контрастный синий цвет
    },
  },
  typography: {
    ...brandTypography,
    h5: { ...brandTypography.h5, color: '#ECECEC' },
  },
  shape: brandShape,
  components: { ...tableHeadCjkOverride, ...dateInputScheme('dark') },
});

export { lightTheme, darkTheme };
